import React from "react";
import styles from "./styles.module.scss";
import { Text } from "@components/Text/Text";
import { Heading } from "@components/Heading/Heading";
import { LinkField } from "@helpers/interfaces/link";
import { Box } from "@components/Box/Box";
import { Link } from "@components/Link/Link";
import { Icon } from "@components/Icon/Icon";
import arrowIcon from "@svg-icons/arrow.component.svg";
export interface BetterAnswerBoxProps {
  Question: string;
  Answer: string;
  CallToAction?: LinkField;
  Url?: string;
  ShowUrl?: boolean;
  Key?: string;
  BetterAnswersPage: boolean;
}

const BetterAnswerBox: React.FC<BetterAnswerBoxProps> = ({
  Question,
  Answer,
  CallToAction,
  Url,
  ShowUrl,
  BetterAnswersPage
}) => {
  return (
    <div className={styles.betterAnswerBoxHeights}>
      <Box className={styles.betterAnswerBox}>
        <Box as="article" className={styles.betterAnswerBoxText}>
          <Heading as="h1" className={styles.headline}>
            {Question}
          </Heading>
        </Box>
        <Heading as="h2" className={styles.headlineSub}>
          SikkerTrafik svarer:
        </Heading>
        <Text>{Answer}</Text>
        {ShowUrl && (
          <Link href={Url} className={styles.link}>
            <span>Læs mere om emnet</span>
            <Icon svg={arrowIcon} className={styles.icon} />
          </Link>
        )}
        {CallToAction && !ShowUrl && (
          <Link href={CallToAction.Url} target="_blank" className={styles.link}>
            <span>{CallToAction.Name}</span>
            <Icon svg={arrowIcon} className={styles.icon} />
          </Link>
        )}
      </Box>
    </div>
  );
};

BetterAnswerBox.defaultProps = {};

export { BetterAnswerBox };
